import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const files = require.context('./modules', false, /\.module\.js/)
const fileEntries = files.keys()
  .map(key => [key.replace(/(\.\/|\.module\.js)/g, ''), files(key).default])
const modules = Object.fromEntries(fileEntries)

export default new Vuex.Store({
  modules,
  getters: {
    unfold: state => state.entry.unfold,
    serviceId: state => state.entry.serviceId,
    systemCode: state => state.entry.systemCode,
    menus: state => state.entry.menus,
    visibleMenus: state => state.entry.menus.filter(item => item.tabVisible),
    useNewMenu: state => state.entry.useNewMenu,
    customMenus: state => state.entry.customMenus,
    menusActiveID: state => state.entry.menusActiveID,
    panes: state => state.entry.panes,
    iframes: state => state.entry.iframes,
    panesHistory: state => state.entry.panesHistory,
    activeKey: state => state.entry.activeKey,
    currentLang: state => state.app.lang,
    isDemo: state => state.app.isDemo,
    microApps: state => state.permission.microApps,
    favorites: state => state.entry.favorites,
    ownStore: state => state.entry.ownStore,
    paidPageFlag: state => state.entry.paidPageFlag,
    notification: state => state.user.notification
  }
})
